import { autoMount } from '../../../utils/autoMount';
import { WorkLocation } from '../../../components/organisms/workLocation';

autoMount({ WorkLocation });
